import { createApp } from 'vue'
import App from './App.vue'



// 排课页面，el-select展开后，没收起，直接点击取消，调用cancelCourseArrange函数，报错Uncaught runtime errors: ResizeObserver loop completed with undelivered notifications.
// 防抖处理 ResizeObserver
function debounce(func, timeout = 100) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}
// 优化 ResizeObserver
if (typeof window !== 'undefined' && window.ResizeObserver) {
  const originalResizeObserver = window.ResizeObserver;
  
  window.ResizeObserver = class extends originalResizeObserver {
    constructor(callback) {
      const debouncedCallback = debounce(callback, 16); // 约60fps
      super(debouncedCallback);
    }
  };
}



const app = createApp(App);



import router from './router'
app.use(router);



// Element Plus 按需引入组件
import { ElDatePicker, ElInput, ElLoading } from 'element-plus'
import { shouldSuppressAppLoading, noopLoadingInstance } from '@/utils/loadingPolicy'
// 引入语言包
import zhCn from 'element-plus/es/locale/lang/zh-cn'

// 为按需引入的组件设置中文语言
app.use(ElDatePicker, {
  locale: zhCn
})

app.use(ElLoading);

app.config.globalProperties.$loadingDiv1 = (options = {}) => {
  return ElLoading.service({
    // 用全局唯一容器做 target，避免多个页面都有 id="div1" 导致选错节点
    target: '#div1',
    fullscreen: false,
    body: false,
    zIndex: 100,
    lock: true,
    background: 'rgba(0, 0, 0, 0.5)',
    ...options,
  })
}


// 引入 Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// // 无需手动引入和注册 Element Plus 组件
// // vue.config.js 中引入的插件会自动按需导入使用的组件
// // // 使用 Element Plus
// app.use(ElementPlus);

// 使用 Element Plus 并设置 locale 为中文
app.use(ElementPlus, {
  locale: zhCn,
})

/**
 * 必须在 app.use(ElementPlus) 之后执行：全量注册可能会替换 ElLoading.service，
 * 过早 patch 会导致策略不生效、仍会转圈。
 */
function installElLoadingServicePolicy() {
  const orig = ElLoading.service.bind(ElLoading)
  ElLoading.service = (options = {}) => {
    const suppress = shouldSuppressAppLoading(options)
    if (suppress) {
      return noopLoadingInstance()
    }
    const { silent: _s, showLoading: _sh, forceLoading: _f, ...clean } = options
    return orig(clean)
  }
}
installElLoadingServicePolicy()

import '@/assets/fonts/font.css' // 引入全局字体样式

// 挂载应用
app.mount('#app')
